// extracted by mini-css-extract-plugin
export var body = "styles-module--body--7b40a";
export var buttonContainer = "styles-module--buttonContainer--21c8f";
export var closeButton = "styles-module--closeButton--28ce8";
export var container = "styles-module--container--dd696";
export var header = "styles-module--header--b28f4";